module.exports = __webpack_public_path__ + "static/quiltedsheep1-b6720cfabd019e4ad134ba011c19c055.jpeg";